import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsapp from "./components/FloatingWhatsapp";
import Home from "./pages/Home";
import Produtos from "./pages/Produtos";
import Sobre from "./pages/Sobre";
import Contato from "./pages/Contato";
import Outsourcing from "./pages/Outsourcing";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminSiteSettings from "./pages/admin/AdminSiteSettings";
import { SiteSettingsProvider } from "./lib/siteSettings";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
      <FloatingWhatsapp />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteSettingsProvider>
          <ScrollToTop />
          <Routes>
            {/* Admin (no public header/footer/whatsapp) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="produtos" element={<AdminProducts />} />
              <Route path="contatos" element={<AdminContacts />} />
              <Route path="conteudo" element={<AdminSiteSettings />} />
            </Route>

            {/* Public site */}
            <Route path="/" element={<PublicShell><Home /></PublicShell>} />
            <Route path="/outsourcing" element={<PublicShell><Outsourcing /></PublicShell>} />
            <Route path="/produtos" element={<PublicShell><Produtos /></PublicShell>} />
            <Route path="/sobre" element={<PublicShell><Sobre /></PublicShell>} />
            <Route path="/contato" element={<PublicShell><Contato /></PublicShell>} />
            <Route path="*" element={<PublicShell><Home /></PublicShell>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </SiteSettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
